import { useMemo } from "react";
import {
  convertBadgeDefinitionsToBadges,
  useBadgeDefinitions
} from "@certa/queries/hooks/instanceSettings.hook.ts";

type ReportBadgesProps = {
  isBadgeTagsEnabled: boolean;
  contentType?: "workflow" | "object";
  typeTag?: string;
};

export const useReportBadges = ({
  isBadgeTagsEnabled,
  contentType,
  typeTag
}: ReportBadgesProps) => {
  const { data: badgeDefinitions, isLoading: isBadgeDefinitionsLoading } =
    useBadgeDefinitions({
      enabled: !!isBadgeTagsEnabled,
      contentType,
      typeTag
    });

  const badges = useMemo(() => {
    return convertBadgeDefinitionsToBadges(badgeDefinitions ?? []);
  }, [badgeDefinitions]);

  const shouldShowBadgeLoadingState =
    isBadgeDefinitionsLoading && isBadgeTagsEnabled;
  return {
    badges,
    shouldShowBadgeLoadingState
  };
};
